export const useTailSpacerMobile = size => {
  switch (size) {
    case "1":
      return "h-1"
    case "2":
      return "h-2"
    case "3":
      return "h-3"
    case "4":
      return "h-4"
    case "5":
      return "h-5"
    case "6":
      return "h-6"
    case "8":
      return "h-8"
    case "10":
      return "h-10"
    case "12":
      return "h-12"
    case "16":
      return "h-16"
    case "20":
      return "h-20"
    case "24":
      return "h-24"
    case "32":
      return "h-32"
    case "40":
      return "h-40"
    case "48":
      return "h-48"
    case "56":
      return "h-56"
    case "64":
      return "h-64"
    default:
      return "h-0"
  }
}
